import {Dictionary, get, groupBy} from "lodash";
import moment from "moment";

export type DataGroupedByDate<T> = {
  date: string;
  groupedData: T[];
}[];

export function groupByDate<T>(
  data: T[],
  path: string,
  dateFormat: string
): DataGroupedByDate<T> {
  // create object grouped by dates
  const grouped: Dictionary<T[]> = groupBy(data, (item) => {
    const prop = get(item, path);
    // hardcoded for now, since like the Dates coming from BE are in the same format
    // for different use cases create an additional param and pass it here
    return moment(prop, "YYYY-MM-DD").format(dateFormat);
  });

  // create array of grouped orders
  return Object.keys(grouped).map((key) => {
    return {
      date: key,
      groupedData: grouped[key],
    };
  });
}
